import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Shopping: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <circle cx='300' cy='600' r='30' />
    <circle cx='570' cy='600' r='30' />
    <path d='m285 240h75v-30s-45 0-45 0c-16.57 0-30 13.43-30 30z' />
    <path d='m596.62 540h-324.33l-60-360h-42.29v-30h67.71l60 360h275.67l55.64-215.74c2.79-13.28-.48-26.94-9.01-37.51-8.58-10.64-21.35-16.75-35.03-16.75h-245.61v-30h245.61c22.79 0 44.07 10.17 58.38 27.92 14.31 17.74 19.75 40.69 14.92 62.97l-.14.57-61.52 238.55z' />
    <path d='m120 180h90s0-30 0-30h-60c-16.57 0-30 13.43-30 30z' />
  </IconBase>
));

Shopping.displayName = 'Shopping';

export default Shopping;
